import BaseNewsletter from '../base-newsletter';

export default class FooterComponent extends BaseNewsletter {}
